<template lang="html">
  <div class="variety-image">
    <HeadedContainer>
      <template v-slot:header>
        {{$ml.get(`Image`)}}
      </template>
      <ImageInput
        :value="image"
        @input="uploadFile"
        :class="{
          'disabled': ($store.getters['crop/base'].owner == 0)
        }"
      />
    </HeadedContainer>
  </div>
</template>

<script>
import { CropAPI, FileAPI } from '@/api'
import ImageInput from '@/components/common/ImageInput'
import HeadedContainer from '@/components/common/HeadedContainer';

export default {
  components: {
    ImageInput,
    HeadedContainer,
  },

  data() {
    return {

    };
  },

  methods: {


    uploadFile(file) {
      if(this.$store.getters['crop/base'].owner == 0) {
        console.log('nope');
      } else {
        return FileAPI.upload(file).then(res => {
          this.$store.commit('crop/setVarietyFile', res.data.id);
          this.save().then(res => {
            this.$store.commit('crop/removeVarietyFile');
          });
        });
      }

    },


    save() {
      return CropAPI.updateCropVariety(this.selected.id, this.selected);
    },
  },

  computed: {
    selected() {
      return this.$store.getters['crop/variety']
    },
    image() {
      return this.selected.cropImage;
    }
  }
}
</script>

<style lang="scss" scoped>

.variety-image {

  position: relative;

  display: flex;
  flex-direction: column;

  .headed-container {
    height: 100%;
  }

  .image-input {
    display: flex;
    align-items: stretch;
    flex-direction: column;

    height: 100%;
    width: 100%;
    border-radius: 0 0 3px 3px;
    overflow: hidden;
    &.disabled {
      pointer-events: none;
      &::v-deep {
        .text {
          display:none;
        }
      }
    }
  }
}


</style>
